import { render, staticRenderFns } from "./Anamnesa.vue?vue&type=template&id=7cd5516f&scoped=true"
import script from "./Anamnesa.vue?vue&type=script&lang=js"
export * from "./Anamnesa.vue?vue&type=script&lang=js"
import style0 from "./Anamnesa.vue?vue&type=style&index=0&id=7cd5516f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd5516f",
  null
  
)

export default component.exports